import requests from "./httpService";

const ProviderServices = {
    getAllProviders: async () => {
        return requests.get(`/provider-list`);
    },
    updateProviderStatus: async (id, body) => {
        return requests.patch(`/seller-commision/update-provider-status/${id}`, body);
    },
    // updateSellerblockStatus: async (id, body) => {
    //     return requests.patch(`/seller/updateBlockStatus/${id}`, body);
    // },
      updateProvider: async (id, body) => {
        return requests.put(`/seller-commision/update-provider/${id}`, body);
    },
  createProvider: async (body) => {
        return requests.post(`/seller-commision/create-commission`, body);
    },
    deleteProvider: async (id) => {
        return requests.delete(`/seller-commision/delete-commission/${id}`);
    },
}

export default ProviderServices;